import gql from 'graphql-tag';

export interface GetTokenDInfo {
  id: number;
  email: string;
}

export interface GetTokenDInfoQueryResult {
  getTokenDInfo: GetTokenDInfo;
}

export const getTokenDInfo = gql`
  query getTokenDInfo($tokenD: String!) {
    getTokenDInfo(tokenD: $tokenD) {
      id
      email
    }
  }
`;

export interface GetProfileUserAccountsInfo {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneCountryCode: string;
  phoneRegionCode: string;
  phoneNumber: string;
}

export interface GetProfileUserAccountsInfoQueryResult {
  getProfileUserAccountsInfo: GetProfileUserAccountsInfo;
}

export const getProfileUserAccountsInfo = gql`
  query getProfileUserAccountsInfo {
    getProfileUserAccountsInfo {
      email
      firstName
      lastName
      phoneCountryCode
      phoneRegionCode
      phoneNumber
    }
  }
`;

export interface checkIfUserEmailExistOnAccountsResult {
  checkIfUserEmailExistOnAccounts: boolean;
}

export const checkIfUserEmailExistOnAccountsQuery = gql`
  query checkIfUserEmailExistOnAccounts($email: String!) {
    checkIfUserEmailExistOnAccounts(email: $email)
  }
`;
